import { apiSlice } from "../../api/apiSlice";

export const rbacApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // @desc: Get Permission list
    getPermissions: builder.query({
      query: () => "/api/rbac/permission",
    }),
    // @desc: Get All Permission Sets
    getPermissionsSet: builder.query({
      query: () => "/api/rbac/permission-set",
      providesTags: ["Permission"],
    }),
    // @desc: Create new Permission Sets.
    addPermissionSet: builder.mutation({
      query: (permissionSetBody) => ({
        url: "/api/rbac/permission-set",
        method: "POST",
        body: { ...permissionSetBody },
      }),
      invalidatesTags: ["Permission"],
    }),
    // @desc: Assign permission set to user.
    assignPermissionSet: builder.mutation({
      query: (assignPermBody) => ({
        url: "/api/rbac/assign",
        method: "POST",
        body: { ...assignPermBody },
      }),
    }),
    // @desc: Assign companies to admin
    assignCompaniesToAdmin: builder.mutation({
      query: ({ userId, companyIds }) => ({
        url: "/api/rbac/admin/companies/assign",
        method: "POST",
        body: { userId, companyIds },
      }),
      invalidatesTags: ["Admin", "Permission"],
    }),
    // @desc: Remove companies from admin
    removeCompaniesFromAdmin: builder.mutation({
      query: ({ userId, companyIds }) => ({
        url: "/api/rbac/admin/companies/remove",
        method: "POST",
        body: { userId, companyIds },
      }),
      invalidatesTags: ["Admin", "Permission"],
    }),
    // @desc: Get admin's managed companies
    getAdminManagedCompanies: builder.query({
      query: (userId) => `/api/rbac/admin/companies/${userId}`,
      providesTags: ["Admin"],
    }),
  }),
});

export const {
  useGetPermissionsQuery,
  useGetPermissionsSetQuery,
  useAddPermissionSetMutation,
  useAssignPermissionSetMutation,
  useAssignCompaniesToAdminMutation,
  useRemoveCompaniesFromAdminMutation,
  useGetAdminManagedCompaniesQuery,
} = rbacApiSlice;
